import { render, staticRenderFns } from "./NtrPranesimai.vue?vue&type=template&id=c848ac32&scoped=true&"
import script from "./NtrPranesimai.vue?vue&type=script&lang=js&"
export * from "./NtrPranesimai.vue?vue&type=script&lang=js&"
import style0 from "./NtrPranesimai.vue?vue&type=style&index=0&id=c848ac32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c848ac32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VContainer,VDataTable})
